import { Button, Input } from '@components';
import { Box, styled } from '@mui/material';

export const StyledButton = styled(Button)(({ theme }) => ({
  alignSelf: 'flex-start',
  [theme.breakpoints.down('md')]: {
    alignSelf: 'normal',
  },
}));

export const ToggleBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 8, 0, 8),
}));

export const TinExcuseInput = styled(Input)(({ theme }) => ({
  '& label': {
    color: theme.palette.divider,
    paddingLeft: theme.spacing(6),
    [theme.breakpoints.up(300)]: {
      whiteSpace: 'normal',
    },
    '&.Mui-focused': {
      color: theme.palette.divider,
    },
    '&.Mui-error': {
      color: theme.palette.error.main,
    },
    '&.Mui-disabled': {
      color: theme.palette.grey.A100,
    },
  },
}));
